import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6cb9603a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=6cb9603a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9603a",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BCol, BFormInput, BFormGroup, BButton, BRow, BForm, BCard, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BCol, BFormInput, BFormGroup, BButton, BRow, BForm, BCard, BContainer})
    

export default component.exports